import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import crypto from "crypto";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function hashIP(ip: string): string {
    return crypto.createHash("sha256").update(ip).digest("hex");
}

export function formatDate(date: Date): string {
    return new Intl.DateTimeFormat("pl-PL", {
        day: "numeric",
        month: "long",
        year: "numeric",
    }).format(date);
}

export function getClientIP(request: Request): string {
    const forwarded = request.headers.get("x-forwarded-for");
    const realIP = request.headers.get("x-real-ip");

    if (forwarded) {
        return forwarded.split(",")[0].trim();
    }

    if (realIP) {
        return realIP;
    }

    return "unknown";
}

export function getTier(score: number, allScores: number[]): string {
    if (allScores.length === 0) return "D";

    const sortedScores = [...allScores].sort((a, b) => b - a);
    const position = sortedScores.indexOf(score);
    const percentile = (position / sortedScores.length) * 100;

    if (percentile <= 5) return "S";
    if (percentile <= 20) return "A";
    if (percentile <= 50) return "B";
    if (percentile <= 80) return "C";
    return "D";
}

export function getTierColor(tier: string): string {
    switch (tier) {
        case "S":
            return "bg-gradient-to-r from-amber-400 to-yellow-500 text-black";
        case "A":
            return "bg-gradient-to-r from-red-500 to-rose-600 text-white";
        case "B":
            return "bg-gradient-to-r from-blue-500 to-indigo-600 text-white";
        case "C":
            return "bg-gradient-to-r from-green-500 to-emerald-600 text-white";
        // ... existing code ...
        default:
            return "bg-gray-500 text-white";
    }
}

export function getInbDeclension(count: number): string {
    if (count === 1) return "inba";

    const units = count % 10;
    const tens = Math.floor((count % 100) / 10);

    if (tens === 1) return "inb";

    if (units >= 2 && units <= 4) return "inby";

    return "inb";
}
